import { Pipe, PipeTransform } from '@angular/core';
import { StateService } from 'src/app/results/sidebar/services/us-states.service';

@Pipe({
    name: 'getAddress',
    standalone: false
})
export class GetAddressPipe implements PipeTransform {

    constructor(private stateService: StateService) {}

    transform(location: any, ...args: string[]): string {
        let address = [];
        let hqLocations;
        if(Array.isArray(location)) {
            hqLocations = location.find((location) => location.is_ushq === true);
        } else {
            hqLocations = location;
        }
        if(args.includes('street')) {
            if (hqLocations?.street1) {
                address.push(hqLocations?.street1);
            }
            if (hqLocations?.street2) {
                address.push(hqLocations?.street2);
            }
        }
        if(args.includes('street1')) {
            address.push(hqLocations?.street1);
        }
        if(args.includes('street2')) {
            address.push(hqLocations?.street2);
        }
        if (args.includes('city') && hqLocations?.city) {
            address.push(hqLocations?.city);
        }
        if (args.includes('stateAbbr')) {
            hqLocations?.state ? address.push(hqLocations?.state) : '';
        }
        if (args.includes('state')) {
            hqLocations?.stateName ? address.push(hqLocations?.stateName) : hqLocations?.state ? address.push(hqLocations?.state) : '';
        }
        if (args.includes('pincode') && hqLocations?.postal_code) {
            address.push(hqLocations?.postal_code);
        }
        if (args.includes('country')) {
            if (hqLocations?.countryName) {
                address.push(hqLocations?.countryName);
            } else if (hqLocations?.country === 'USA' || hqLocations?.country === 'US') {
                address.push('United States');
            } else {
                const country = this.stateService.getCountriesList().filter((element) => element.abbreviation === hqLocations?.country);
                if (country[0] && country[0].name && country[0].name !== '') {
                    address.push(country[0].name);
                } else {
                    address.push(hqLocations?.country);
                }
            }
        }
        return address.join(', ');
    }
}
